import { render, staticRenderFns } from "./DelegationStartView.vue?vue&type=template&id=87ca7a1c&scoped=true&"
import script from "./DelegationStartView.vue?vue&type=script&lang=js&"
export * from "./DelegationStartView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca7a1c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87ca7a1c')) {
      api.createRecord('87ca7a1c', component.options)
    } else {
      api.reload('87ca7a1c', component.options)
    }
    module.hot.accept("./DelegationStartView.vue?vue&type=template&id=87ca7a1c&scoped=true&", function () {
      api.rerender('87ca7a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationStartView.vue"
export default component.exports